import { render, staticRenderFns } from "./AddApiToken.vue?vue&type=template&id=2f4fa44e&scoped=true"
import script from "./AddApiToken.vue?vue&type=script&lang=ts"
export * from "./AddApiToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fa44e",
  null
  
)

export default component.exports